



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'btn' })
export default class BtnComponent extends Vue {
  @Prop({ type: Boolean, default: false }) public uppercase!: boolean;
  @Prop({ default: '' }) public to!: string;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;
  @Prop({ type: Boolean, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, default: false }) public danger!: boolean;
  @Prop({ type: Boolean, default: false }) public gray!: boolean;
}
